<div class="ag-grid-dropdown-menu-cell-renderer__wrapper">
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item style="display: none"></button>
    <ng-container *ngFor="let option of filteredOptions; trackBy: trackByLabel">
      <button mat-menu-item (click)="option.onRowClick(params?.data)">
        <i [class]="option.icon"></i> {{ option.label }}
      </button>
    </ng-container>
  </mat-menu>
</div>
